import {
  Container,
  Info,
  Views,
  Subscribers,
  ContactUs,
  InfoContact,
  Empty,
  ImageContainer,
  CardContainer,
  CardSection,
} from "./styles";
import History from "../../../assets/images/Activity History (1).svg";

import letter from "../../../assets/images/Lettersmall.svg";
import eye from "../../../assets/images/Eye.svg";

interface CommunityTabProp {
  isCommunityActive: boolean;
  profile: any;
  subscribers: any;
}
export default function CommunityTab({ isCommunityActive, profile, subscribers }: CommunityTabProp) {
  return (
    <Container hidden={!isCommunityActive}>
      <div className="md:grid lg:grid-cols-12 md:grid-cols-10 ">
        <div className="lg:col-span-3 md:col-span-4">
          <Info hidden={!isCommunityActive}>
            <Views>
              <img src={eye} alt="" />
              <p>{profile?.pageViews} Page Views</p>
            </Views>
            <Subscribers>
              <img src={letter} alt="" />
              <p>{profile?.subscribers} Subscribers</p>
            </Subscribers>
          </Info>
        </div>
        <div className=" flex justify-center lg:col-span-7 md:col-span-6 ">
          {subscribers?.length === 0 ? (
            <Empty>
              <ImageContainer>
                <img src={History} alt="shopping" />
              </ImageContainer>
              <p>No Subcribers Yet</p>
            </Empty>
          ) : (
            <>
              <CardContainer className="active">
                {subscribers?.map((subsciber: any) => (
                  <CardSection className="" key={subsciber.uuid}>
                    <h3>{subsciber?.email}</h3>
                  </CardSection>
                ))}
              </CardContainer>
            </>
          )}
        </div>
        <div className="lg:col-span-3 md:col-span-0 "></div>
      </div>
      <InfoContact>
        Need help?{" "}
        <ContactUs>
          {" "}
          <a href="https://wa.me/message/MDP76I5CDKCGG1" target="_blank" rel="noopener noreferrer">
            Contact Us
          </a>
        </ContactUs>{" "}
      </InfoContact>
    </Container>
  );
}
